import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PresentationModeState } from './presentation-mode.models';
import { PRESENTATION_MODE_KEY } from './presentation-mode.reducer';

export const presentationModeFeatureSelector = createFeatureSelector<PresentationModeState>(PRESENTATION_MODE_KEY);
// eslint-disable-next-line
export const getPresentationModeState = () =>
  createSelector(presentationModeFeatureSelector, (state: PresentationModeState) => state.enabled);
